import { Modal } from 'antd';
import styled from 'styled-components';


export const VideoModal = styled(Modal)`
  &.ant-modal{
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  & .ant-modal-header{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & .ant-modal-body{
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
